import React from "react";
import { Container } from "react-bootstrap";
import "./LandingPage.css";
import "./AboutPage.css";

export default function PrivacyPage() {
  return (
    <div className="about-page">
      <main className="about-content">
        <Container>
          <div className="about-header">
            <h1 className="about-title">Privacy Policy</h1>
            <p className="about-subtitle">
              Last updated: June 10, 2026 • Governing jurisdiction: Ontario,
              Canada
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">1. Introduction</h2>
            <p className="about-text">
              This Privacy Policy describes how Podium ("we," "us," or "our")
              collects, uses, and handles information in connection with the
              Podium hockey league management platform (the "Service"). By using
              the Service, you acknowledge and agree to the practices described
              in this policy.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">2. Information We Collect</h2>
            <p className="about-text">
              We collect information you provide directly when you register an
              account, including your name and email address. We also collect
              information you enter while using the Service, such as league
              data, player names, game scores, and statistics.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">3. How We Use Information</h2>
            <p className="about-text">
              Information is used solely to operate and provide the Service —
              including managing leagues, seasons, teams, players, and games. We
              do not sell, rent, or share your personal information with third
              parties for marketing purposes.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">4. Data Storage</h2>
            <p className="about-text">
              Your data is stored on servers. While we take reasonable steps to
              protect your information, we make no warranties or guarantees
              regarding the security, availability, accuracy, or integrity of
              any data stored through the Service. You are responsible for
              maintaining your own records of any information you consider
              important.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">5. Disclaimer of Liability</h2>
            <p className="about-text">
              To the maximum extent permitted by applicable law in Ontario,
              Canada, we are not liable for any loss, corruption, unauthorized
              access, or deletion of data. We are not liable for any direct,
              indirect, incidental, special, or consequential damages arising
              from your use of or inability to use the Service, including any
              loss of data.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">6. Public Information</h2>
            <p className="about-text">
              Certain information — including league standings, game results,
              player statistics, and team rosters — may be displayed publicly
              without requiring authentication. Do not enter information into
              the Service that you do not wish to be potentially visible to
              others.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">
              7. Cookies and Local Storage
            </h2>
            <p className="about-text">
              The Service uses browser localStorage to store your authentication
              session and league preferences. No third-party tracking cookies
              are used.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">8. Children's Privacy</h2>
            <p className="about-text">
              The Service is not directed at children under the age of 13. We do
              not knowingly collect personal information from children under 13.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">9. Changes to This Policy</h2>
            <p className="about-text">
              We may update this Privacy Policy from time to time. Continued use
              of the Service after changes are posted constitutes your
              acceptance of the updated policy.
            </p>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">10. Contact</h2>
            <p className="about-text">
              If you have questions about this Privacy Policy, you may contact
              the league administrator for your league.
            </p>
          </div>
        </Container>
      </main>
    </div>
  );
}
